export const isLabelField = Symbol('isLabel');
export const deepField = Symbol('deep');
export const keyField = '_id'; // к сожалению vue-virtual-scroller не умеет работать с ключами символами, только со строками :(
export const parentField = Symbol('parent');
